
import React, { FC } from 'react'
import classnames from 'classnames';

import { CircleAddSlim } from '../../images/CircleAddSlim';

import './AddButtonWithText.css';

interface Props {
  onClick(): void;
  className: string;
}

const AddButtonWithText: FC<Props> = (props) => {
  return (
    <button className={classnames('cmp-addbuttonwithtext', props.className)} onClick={props.onClick}>
      <CircleAddSlim size={30}/>
      <div className="theme-group accent color font-subhead">
        {props.children}
      </div>
    </button>
  );
}

export default AddButtonWithText;
